import type { Occurrence } from "./occurrences";

export enum EventStatus {
  DRAFT = "Draft",
  ACTIVE = "Active",
  INACTIVE = "Inactive",
  ARCHIVED = "Archived",
}

export enum DurationUnits {
  HOURS = "Hours",
  DAYS = "Days",
  WEEKS = "Weeks",
  MONTHS = "Months",
}

export enum EventType {
  IN_PERSON = "In Person",
  ONLINE = "Online",
  HYBRID = "Hybrid",
}

export enum ActivityLevel {
  LOW = "Low",
  MODERATE = "Moderate",
  VIGOROUS = "Vigorous",
}

export enum LocationType {
  SINGLE = "Single Location",
  MULTIPLE = "Multi-Location (same city)",
  MULTI_CITY = "Multi-City",
}

interface NameReference {
  id: string;
  name: string;
}

interface LocationAddress {
  address_line_1: string;
  administrative_area_level_2: string;
  state: string;
  country: string;
  postal_code: string;
  [key: string]: unknown;
}

interface LocationCity {
  id: string;
  city: string;
  country: {
    id: string;
    name: string;
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

export interface Location {
  id: string;
  event_id: string;
  event_lat_lng: string;
  address: LocationAddress;
  image: string;
  mobility: string;
  communication: string;
  sensory: string;
  city_id: number;
  city: LocationCity;
  google_place_id: string;
}

export interface EventBase {
  status?: EventStatus | null;
  title: string;
  category_id: number;
  subcategory_id?: number | null;
  duration?: number | null;
  duration_units?: DurationUnits | null;
  approx_length?: boolean | null;
  type?: EventType | null;
  radius?: number | null;
  transportation?: string | null;
  description?: Record<string, unknown> | null;
  host?: string | null;
  terms_available?: unknown[] | null;
  within_term_availability?: boolean | null;
  event_academic_theme?: unknown[] | null;
  price_student?: number | null;
  age_requirement?: boolean | null;
  tags?: unknown[] | null;
  url?: string | null;
  online_location?: string | null;
  includes?: unknown[] | null;
  includes_other?: unknown[] | null;
  activity_level?: ActivityLevel | null;
  itinerary?: Record<string, unknown> | null;
  packing_list?: unknown[] | null;
  packing_other?: unknown[] | null;
  primarily_attended_by?: unknown[] | null;
  accommodation?: string | null;
  participants_id?: number | null;
  hours?: string | null;
  location_type?: LocationType | null;
  accommodation_description?: Record<string, unknown> | null;
  is_outdoors?: boolean | null;
  marketplace: boolean;
  entity_id: string;
  image?: string | null;
  event_locations?: Location[];
  program_types?: (NameReference | string | null)[];
}

export interface Event extends EventBase {
  id: string;
  event_occurrences?: Occurrence[];
  html_description?: string | null;
  updated_at?: string | null;
  archived_at?: string | null;
  created_by?: string | null;
  updated_by?: string | null;
}

export interface EventWithLocations extends Event {
  event_category: NameReference;
  event_subcategory: NameReference;
  event_locations?: Location[];
}

export interface EventResponseBaseLocations {
  data: EventWithLocations;
}

export interface Excursion extends Occurrence {
  event: EventWithLocations;
  price: number;
}
